export default __webpack_public_path__ + "static/media/konst_bg.363644ec.svg";